<ppl-accordion [title]="'Timesheet Summary'" [isOpen]="true">

  @if(!isReadOnly) {
  <div>

    <div class="custom-row">
      @if(entry !== 'participantEnrollment'){
      <div class="mr-2">

        <ppl-button label="View Time Off" icon="fa fa-plus" [customClass]="'primary-button'" [iconPosition]="'left'"
          (click)="viewTimeOff()" *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'edit']"></ppl-button>
      </div>

      @if(!disableAddTimeEntries){

      <div class="mr-2">
        <ppl-button label="Submit Time Off" icon="fa fa-plus" [customClass]="'primary-button'" [iconPosition]="'left'"
          (click)="addTimeoff()" *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'edit']"></ppl-button>
      </div>
      @if((isPA && (hasADAAttr || showAddEntries)) || !isPA) {
      <div class="mr-2">
        <ppl-button label="Add Time Entries" icon="fa fa-plus" [customClass]="'primary-button'" [iconPosition]="'left'"
          (click)="addTimeentries()" *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'edit']"></ppl-button>
      </div>
      }
      }
      }

    </div>
  </div>
  }
  @if(pastDueTSMessage){
    <div class="warning-message mb-4 alert alert-warning pt-3 pb-3">
      {{pastDueTSMessage}}
    </div>
  }

  <ppl-accordion [title]="'In Process Payroll'" [isOpen]="true">
    @if(inProgressPayroll?.length > 0){
    @if(isMobileView) {
    <div class="card-layout">
      <div class="card" *ngFor="let row of inProgressPayroll">
        <div class="card-item">
          <strong>{{ row.consumerName }} </strong>
          <div class="status">
            {{ row.participantPPLId }}
          </div>
        </div>
        <div class="card-item">
          <div class="btn-group">
            <div class="custom-row">
              <div class="mr-1">
                <ppl-button ariaLabel="View" label="View" [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="onAction({data: row, action: 'view'}, false)"></ppl-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    } @else {
    <ppl-list-table rowDataAccessibilityKey="tas_timesheetheader_detail_id" [disableSort]="false" [disableSearch]="true"
      [showCustomSearch]="false" [enableActions]="true" [disableSelection]="true" [pageConfig]="programName"
      [sharedDataKey]="sharedDataKey" [loadPage]="true" [actionButtons]="actionButtons"
      [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="actionsToBeHidden"
      (gridAction)="onAction($event, false)" [data]="inProgressPayroll" [pagination]="true" [from]="'claims'"
      [jsonList]="'list_provider_timesheet_in_process'">
    </ppl-list-table>
    }
    }@else {
    <nz-row>
      <p>No Data found</p>
    </nz-row>
    }
  </ppl-accordion>

  <ppl-timesheet-provider-processed-list></ppl-timesheet-provider-processed-list>

</ppl-accordion>


<div class="filter-panel">
  <ng-template #timesheetDialog let-cancel="cancel">
    <ppl-timesheets-add-entries [entryType]="timeEntry" [payPeriod]="filetredPayPeriod" [consumers]="consumers"
      [action]="action" [timesheetData]="timesheetData" [entryPage]="timeEntry" [isReadOnly]="isReadOnly"
      (timesheetAdded)="timesheetAdded($event)"></ppl-timesheets-add-entries>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #timesheetViewDialog let-cancel="cancel">
    <ppl-timesheet-view [isProcessed]="isProcessed" [consumers]="consumers" [providerId]="providerId"
      [payrollScheduleId]="payrollScheduleId" [isReadOnly]="isReadOnly"></ppl-timesheet-view>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #timeoffViewDialog let-cancel="cancel">
    <ppl-timesheet-view [isViewTimeOff]="isViewTimeOff" [consumers]="consumers" [providerId]="providerId"
      [isReadOnly]="isReadOnly"></ppl-timesheet-view>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #tepAlertDialog let-cancel="cancel">
    <div [innerHTML]="currentTEPAlert?.alertMsg"></div>
  </ng-template>
</div>